import { useSelector, useDispatch } from "react-redux";
import { hideModal, basicModalShowHide, largeModalShowHide } from "../../features/modalSlice";

const ModalUI = (props) => {
	const { isOpen, title } = useSelector((state) => state.modal);
	const dispatch = useDispatch();

	const closeModal = () => {
		dispatch(hideModal());
	};
	return (
		<div
			className={isOpen ? "modal show" : "modal"}
			id="disabledAnimation"
			tabIndex={-1}
			aria-modal="true"
			role="dialog"
			style={{ display: isOpen ? "block" : "none" }}
		>
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">{title}</h5>
						<button
							type="button"
							className="btn-close"
							onClick={() => closeModal()}
						/>
					</div>
					<div className="modal-body">{isOpen && props.children}</div>
				</div>
			</div>
		</div>
	);
};

export const BasicModal = (props) => {
	const dispatch = useDispatch();
	const { isBasicModal, title } = useSelector((state) => state.modal);

	return isBasicModal ? (<>
		<div
			className="modal-backdrop fade show"
			style={{ backgroundColor: "rgba(0, 0, 0, 0.9)" }}
		></div>
		<div
			className="modal fade show"
			id="basicModal"
			tabIndex={-1}
			aria-modal="true"
			role="dialog"
			style={{ display: "block" }}
		>
			<div className="modal-dialog" style={{ overflow: "visible" }}>
				<div className="modal-content" style={{ overflow: "visible" }}>
					<div className="modal-header">
						<h5 className="modal-title">{title}</h5>
						<button
							type="button"
							className="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
							onClick={() => dispatch(basicModalShowHide())}
						/>
					</div>
					<div className="modal-body" style={{ overflow: "visible" }}>
						{props.children}
					</div>
				</div>
			</div>
		</div>
	</>) : null;
};

export const LargeModal = (props) => {
	const dispatch = useDispatch();
	const { isLargeModal, title } = useSelector((state) => state.modal);

	return isLargeModal ? (<>
		<div
			className="modal-backdrop fade show"
			style={{ backgroundColor: "rgba(0, 0, 0, 0.9)" }}
		></div>
		<div
			className="modal fade show"
			id="basicModal"
			tabIndex={-1}
			aria-modal="true"
			role="dialog"
			style={{ display: "block" }}
		>
			<div className="modal-dialog modal-xl" style={{ overflow: "visible" }}>
				<div className="modal-content" style={{ overflow: "visible" }}>
					<div className="modal-header">
						<h5 className="modal-title">{title}</h5>
						<button
							type="button"
							className="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
							onClick={() => dispatch(largeModalShowHide())}
						/>
					</div>
					<div className="modal-body" style={{ overflow: "visible" }}>
						{props.children}
					</div>
				</div>
			</div>
		</div>
	</>) : null;
}

export default ModalUI;
